// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarCatalogoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/catalogo/migrar-todas
 * (controllers/migration/catalogo.php::migrar_todas).
 *
 * Um unico campo, OBRIGATORIO: a franquia cuja carga de catalogo vai rodar.
 *
 * Na E2 o campo e opcional porque "todas" e uma operacao valida (longa, mas
 * valida). Aqui NAO E: o export global de catalogo estoura o limite de
 * execucao do Creator (erro 9430, medido). Migrar a rede = 62 execucoes desta
 * rota, uma por franquia, cada uma no seu run — e o campo ausente e recusado
 * na borda, nunca interpretado.
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido do navegador
 * (armadilha A1).
 */
import { registerContract } from './validate'

export interface Migration_MigrarCatalogoInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarCatalogoInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
